import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { AnalyticsTrigger, Button, Separator, TSeparatorSpacing } from 'telia-front-react';
import SearchStore, { CATEGORY_ARCHIVED, DOCUMENT_CATEGORY, SERVICE_CATEGORY } from '../stores/SearchStore';
import { FetchStatus } from '../util/FetchStatus';
import { waitForRender } from '../util/HtmlUtil';
import { findClosestContainer, findRowsCountInContainer, focusRowInContainer } from './SearchHtmlUtil';

interface ShowMoreButtonProps {
  searchStore?: SearchStore;
  theme?: 'light' | 'dark';
  category: string;
  separatorSpacing?: TSeparatorSpacing;
}

@observer
class ShowMoreButton extends React.Component<ShowMoreButtonProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const translate = this.context.translate;
    const {
      category,
      theme,
      searchStore: { numberOfMoreResults },
      separatorSpacing,
    } = this.props;

    const noOfMoreResults: number = numberOfMoreResults(category);
    if (isNaN(noOfMoreResults) || noOfMoreResults < 1) {
      return null;
    }
    const isArchive: boolean = category.includes(CATEGORY_ARCHIVED);
    const isServiceOrDocumentCategory = category === DOCUMENT_CATEGORY || category === SERVICE_CATEGORY;

    const handleLoadMoreClick = async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
      const container = findClosestContainer(event);
      const rowsCountBeforeFetch = findRowsCountInContainer(container);
      await this.props.searchStore.addToSearchResults(isArchive, isServiceOrDocumentCategory ? category : undefined);
      await waitForRender();
      focusRowInContainer(container, rowsCountBeforeFetch);
    };

    return (
      <>
        <Separator spacing={separatorSpacing || 'xsmall'} color="invisible" />
        <p className="text-center">
          <AnalyticsTrigger
            trigger={{
              id: `Tab - ${this.props.category} - Button - Laadin juurde`,
              callback: 'onClick',
            }}
          >
            <Button
              size="small"
              variant="secondary"
              theme={theme || 'light'}
              isLoading={this.isLoading()}
              text={`${translate('search.loadMore')} (+${noOfMoreResults})`}
              onClick={handleLoadMoreClick}
            />
          </AnalyticsTrigger>
        </p>
      </>
    );
  }

  private isLoading = () => {
    const {
      searchStore: { searchWrappers },
      category,
    } = this.props;
    return searchWrappers[category].status === FetchStatus.FETCHING_MORE;
  };
}

export default inject('searchStore')(ShowMoreButton);
